type ReturnStepHeadingProps = {
  header?: string;
  subheader?: string;
};

export const readRichText = (value: unknown): string | undefined => {
  if (typeof value === "string" && value.trim() !== "") {
    return value;
  }

  if (
    value !== null &&
    typeof value === "object" &&
    "gearsResolvedRichText" in value &&
    typeof value.gearsResolvedRichText === "string" &&
    value.gearsResolvedRichText.trim() !== ""
  ) {
    return value.gearsResolvedRichText;
  }

  return undefined;
};

export const ReturnStepHeading = ({
  header,
  subheader,
}: ReturnStepHeadingProps) => {
  const subheaderHtml = readRichText(subheader);
  const heading = header?.trim();

  if (!heading && !subheaderHtml) {
    return null;
  }

  return (
    <div className="bg-background-page px-component-spacing-sm pb-10 pt-12 text-center lg:pb-14 lg:pt-16">
      {heading && (
        <h1 className="mx-auto max-w-3xl font-secondary text-heading-xl text-balance text-black lg:text-heading-2xl">
          {heading}
        </h1>
      )}
      {subheaderHtml && (
        <div
          className="mx-auto mt-4 max-w-xl font-primary text-body-md text-black [&_p]:m-0"
          dangerouslySetInnerHTML={{ __html: subheaderHtml }}
        />
      )}
    </div>
  );
};
